import React from 'react';

/** Logos officiels de la Ville de Beaconsfield. Contrairement à Brossard, la variante
    blanche existe : pas besoin de la fabriquer avec un filtre CSS. */
const LOGO_COLOR = 'https://www.beaconsfield.ca/themes/beaconsfield/assets/medias/images/icons/beaconsfield_logo_horizontal_couleur.svg';
const LOGO_WHITE = 'https://www.beaconsfield.ca/themes/beaconsfield/assets/medias/images/icons/beaconsfield_logo_horizontal_blanc.svg';
interface LogoProps {
  className?: string;
  variant?: 'color' | 'light';
}
export function Logo({
  className = '',
  variant = 'color'
}: LogoProps) {
  return <span className={`inline-flex items-center ${className}`} data-id="element-1826" data-mp="dspjpylc3718">
      <img src={variant === 'light' ? LOGO_WHITE : LOGO_COLOR} width={200} height={60} alt="Ville de Beaconsfield" className="h-[52px] w-auto shrink-0" data-id="element-1827" data-mp="duir5g3rtvaa" />
    </span>;
}